import React from "react";
import { AlertSeverity, useAlerts } from "../AlertProvider/AlertProvider";

type CopyToClipboardWrapperProps = React.PropsWithChildren<{
  value?: string | null | undefined;
  alertMessage?: string;
  onCopied?: () => void;
}>;

function CopyToClipboardWrapper(props: CopyToClipboardWrapperProps) {
  const { children, value, alertMessage } = props;
  const { sendNewAlert } = useAlerts();

  const copyToClipboard = async () => {
    if (value) {
      await navigator.clipboard.writeText(value);
      props.onCopied?.();
      sendNewAlert(alertMessage ?? "Copied to clipboard!", AlertSeverity.Success);
    }
  };

  return <div onClick={copyToClipboard}>{children}</div>;
}

export default CopyToClipboardWrapper;
